// extracted by mini-css-extract-plugin
export default {"form":"newtaskform_form__Q3S3R","input":"newtaskform_input__h2kRm"};